export default "__VITE_ASSET__Cg7UhHRO__"